import { useState } from 'react';
import Cropper from 'react-easy-crop';

import Button from '../button/Button';
import Modal, { ModalType } from '../modal/Modal';

const noop = () => {
  // noop
};

const cropperMediaProps = {
  playsInline: true
};

type UploadVideoModal = {
  preview: string;
  isLoading?: boolean;
  aspectRatio?: number;
  errorMessage?: string;
  cropShape?: 'round' | 'rect';
  children?: React.ReactNode;
  isUploadButtonDisabled?: boolean;
  onClose: () => void;
  uploadVideo: () => void;
};

const UploadVideoModal = ({
  preview,
  isLoading,
  errorMessage,
  cropShape,
  aspectRatio,
  onClose,
  uploadVideo,
  children,
  isUploadButtonDisabled
}) => {
  const [errorFromCropper, setErrorFromCropper] = useState<string | null>(null);
  const handleSaveChanges = async () => {
    try {
      await uploadVideo();
      onClose();
    } catch (err) {
      setErrorFromCropper(err.message);
    }
  };

  const setVideoRef = (ref: React.RefObject<HTMLVideoElement>) => {
    // Cropper autostarts video and we stop it to also show first frame
    ref.current.pause();
  };

  return (
    <Modal
      visible
      type={ModalType.VERY_SMALL}
      onClose={onClose}
      minHeight="500px"
    >
      <div className="py-12 px-10 h-full overflow-hidden">
        <div className="w-full aspect-4/5 mx-auto relative rounded-xl overflow-hidden">
          <Cropper
            aspect={aspectRatio || 1}
            crop={{ x: 0, y: 0 }}
            zoom={1}
            video={preview}
            cropShape={cropShape || 'round'}
            showGrid={false}
            restrictPosition
            onCropChange={noop}
            onZoomChange={noop}
            objectFit="contain"
            onCropComplete={noop}
            mediaProps={cropperMediaProps}
            setVideoRef={setVideoRef}
          />
        </div>
        <div className="mt-6 text-caption text-gray-500 flex justify-center">
          Confirm the video is in the right position or close modal to cancel
        </div>

        {children}

        <div className="mt-10">
          {errorMessage ||
            (errorFromCropper && (
              <div className="mb-2 text-center text-red-500">
                {errorMessage || errorFromCropper}
              </div>
            ))}
          <Button
            disabled={isUploadButtonDisabled}
            loading={isLoading}
            onClick={() => handleSaveChanges()}
          >
            Upload
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadVideoModal;
